/**
 * Service pour les opérations sur les commentaires
 * Aucune logique métier, uniquement des appels API
 */

import { api, endpoints } from './api.js'

export const commentsService = {
  list: (quoteId) => api.get(endpoints.comments.list(quoteId)),

  create: (data) => api.post(endpoints.comments.create(), data),

  update: (commentId, data) => api.patch(endpoints.comments.update(commentId), data),

  delete: (commentId) => api.delete(endpoints.comments.delete(commentId))
}
